/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  ComboBox,
  Button,
  FormLabel,
  Table,
  TableContainer,
  DataTableSkeleton,
  CodeSnippetSkeleton,
  TableToolbar,
  TableBody,
  TableRow,
  TableCell,
  FormGroup,
  TextInput,
  TableSelectRow,
  TableHeader,
  TableHead,
  DataTable,
  DropdownSkeleton,
  TableToolbarContent,
  TableBatchActions,
  TableBatchAction,
  Loading,
  Tabs,
  Tab,
} from 'carbon-components-react';
import '../../scss/custom.scss';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import Collaborate16 from '@carbon/icons-react/lib/collaborate/16';
import UserAdmin16 from '@carbon/icons-react/lib/user--admin/16';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import { CheckmarkOutline16, Error16, Add16, Send16 } from '@carbon/icons-react/lib';
import moment from 'moment';
import { v4 as uuid } from 'uuid';
import Data16 from '@carbon/icons-react/lib/data--1/16';
import {
  RenderDataTableCell,
  NoRecordsPlaceholder,
} from '../../helpers/jsonschemaform/DataTableExtention';
import { me, api } from '../../helpers/api/api';
import { showNotification } from '../../helpers/notification/BaseNotification';
import {
  getError,
  entitiesLabels,
  apioperation,
  getSuccess,
  DateFormat,
} from '../../helpers/Constants';
import { CanExecuteAction, IsInRole } from '../../helpers/authorization/Policies';
import { AppContext } from '../../helpers/context/AppContext';
import PageBreadCrumb from '../../helpers/PageBreadCrumb';
import { WFActionModal } from '../common/WFActionModal';
import DateTimePicker from '../../helpers/DateTimePicker';
import ReportRepository from '../../helpers/api/ReportRepository';
import { Online, Offline } from '../common/OnLineOffLine';
import { ChangeCompilerModal } from './ChangeCompilerModal';
import { ConfirmCompilerModal } from './ConfirmCompilerModal';
import { element } from 'prop-types';

//RITM1510731
const quarterMonths = {
  Q1: [0, 1, 2],
  Q2: [3, 4, 5],
  Q3: [6, 7, 8],
  Q4: [9, 10, 11]
};
//End

export default class ReportSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenInfo: false,
      isOpenInfoDetail: false,
      isChangeRequestModalOpen: false,
      isConfirmRequestModalOpen: false,
      withApprover: true,
      approvers: [],
      reportSummary: null,
      isLoading: true,
      compiler:null,

      isLoadingOptions: true,
      disciplineOptions: [],

      isReportFormOpen: false,
      validationMessages: [],
      isSubmitted: false,

      isApprovalModalOpen: false,
      approvalModalAction: '',
      approver: null,
      approvalStartDate: null,
      approvalEndDate: null,
      approverOptions: [],
      isLoadingApproverOptions: true,
      approvalValidationMessages: [],
      approvalValidationEnabled: false,
      withTimeApproval: false,
      // Form Ricerca
      isOpenFilter: false,
      compilerFilter: null,
      dataApproverFilter: null,
      divisionManagerFilter: null,
      codeFilter: this.getHashtag(),
      approvalNotes: null,
    };
  }

  getHashtag = () => {
    if (this.props.location?.hash != null && this.props.location.hash.length > 1) {
      return decodeURIComponent(this.props.location.hash.substring(1));
    }
    return null;
  };

  handleApprovalStartDateChange = (inputName, inputValue) => {
    this.setState({ approvalStartDate: inputValue }, () =>
      this.validateApproval(this.state.approvalValidationEnabled)
    );
  };

  handleApprovalEndDateChange = (inputName, inputValue) => {
    this.setState({ approvalEndDate: inputValue }, () =>
      this.validateApproval(this.state.approvalValidationEnabled)
    );
  };

  handleApproverSelect = (selectedItem) => {
    this.setState({ approver: selectedItem });
  };

    handleCloseApprovalModal = () => {
    this.setState({ isApprovalModalOpen: false }, this.clearApprovalForm);
  };

  handleCloseChangeCompilerModal = () => {
    this.setState({ isChangeRequestModalOpen: false }, this.clearChangeCompilerForm);
  };
  handleCloseConfirmCompilerModal = () => {
    this.setState({ isConfirmRequestModalOpen: false }, this.clearChangeCompilerForm);
  };

  handleApprovalNotesChange = (e) => {
    this.setState({ approvalNotes: e.target.value });
  };

  clearChangeCompilerForm = () => {
    this.setState({ approvalNotes: '', approver: null });
  };
  handleConfirmCompilerModal = () => {
    const data = {
      ids: this.state.selectedData.map((r) => r.id),
      owner: this.state.approver,
      workflowNotes: this.state.approvalNotes,   
    };

    this.setState({
      isLoadingWFOperation: true,
    });
    api
      .put(`/reports/confirmCompiler/`, data, data.ids) 
      .then((response) => {
        if (response.status === 200) {
          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            getSuccess(entitiesLabels.REPORT, apioperation.PUT)
          );
          this.setState({
            isLoadingWFOperation: false,
            isConfirmRequestModalOpen: false,
            // isLoading: true,
            // itemList: []
          });
          this.getReportSummary();
        } else {
          showNotification.error();
          this.setState({
            isLoadingWFOperation: false,
          });
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, error.response, 'ERROR')
        );
        this.setState({
          isLoadingWFOperation: false,
        });
      })
      .finally(() => {});
  };

  handleChangeCompilerModal = () => {
    const data = {
      ids: this.state.selectedData.map((r) => r.id),
      owner: this.state.approver,
      workflowNotes: this.state.approvalNotes,   
    };

    this.setState({
      isLoadingWFOperation: true,
    });
    api
      .put(`/reports/changeCompiler/`, data, data.ids) 
      .then((response) => {
        if (response.status === 200) {
          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            getSuccess(entitiesLabels.REPORT, apioperation.PUT)
          );
          this.setState({
            isLoadingWFOperation: false,
            isChangeRequestModalOpen: false,
            // isLoading: true,
            // itemList: []
          });
          this.getReportSummary();
        } else {
          showNotification.error();
          this.setState({
            isLoadingWFOperation: false,
          });
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, error.response, 'ERROR')
        );
        this.setState({
          isLoadingWFOperation: false,
        });
      })
      .finally(() => {});
  };

  handleYearSelect = (selectedItem) => {
    this.setState({
      year: selectedItem.selectedItem ? parseInt(selectedItem.selectedItem, '10') : null,
    });
  };

  handleMonthSelect = (selectedItem) => {
    this.setState({ month: selectedItem.selectedItem ? selectedItem.selectedItem.id : null });
  };

  handleTrimesterSelect = ({ selectedItem }) => {
    // console.log('handleTrimesterSelect', selectedItem);
    this.setState({ trimester: selectedItem ? selectedItem.id : null });
  };

  handleCloseApprovalModal = () => {
    this.setState({ isApprovalModalOpen: false }, this.clearApprovalForm);
  };

  validateIntervalCoverage = (reports, report, end) => {
    if (report.end >= end) return true;
    const interleavedReports = reports.filter((r) => {
      let reportEnd = report.end;
      // Object.assign(reportEnd, report.end);
      // reportEnd.setDate(reportEnd.getDate() + 1);
      reportEnd = moment(reportEnd).add(1, 'days').valueOf();
      return r.start <= reportEnd && r.end > report.end;
    });
    if (interleavedReports.length === 0) return false;
    const latestInterleavedReport = interleavedReports.filter(
      (r) => r.end === Math.max(...interleavedReports.map((r) => r.end))
    )[0];
    return this.validateIntervalCoverage(reports, latestInterleavedReport, end);
  };

  validateApproval = (isValidationEnabled) => {
    if (!isValidationEnabled) return true;
    const validationMessages = [];


    const selectedReportIds = this.state.selectedData.map((r) => r.id);

    const reportsFiltered = this.state.reportSummary.reports.filter((r) =>
      selectedReportIds.includes(r.id)
    );

    if (this.state.approvalTimeIntervalType === 'month') {

      const sortedObj = {};
      reportsFiltered.forEach(e => {       // loop over all selected reports
        const k = e.start.slice(0, 7);       // key in YYYY-MM (e.g. 2019-10)
        const fk = `${k}-01`;                // key with appended '-01'   
        sortedObj[fk] = sortedObj[fk] || []; // create new entry if no value for key exists
        sortedObj[fk].push(e);               // add key to existing list
      });

      const sortedArr = Object.entries(sortedObj).sort((a, b) => new Date(a[0]) - new Date(b[0]));

      for (var i = 0; i < sortedArr.length; i++) {
        var minDate = Math.min(...sortedArr[i][1].map((e) => new Date(e.start)));
        var maxDate = Math.max(...sortedArr[i][1].map((e) => new Date(e.end)));

        var validationDate = new Date(sortedArr[i][0]) //start of the month date
        var d1 = new Date(validationDate.getUTCFullYear(), validationDate.getUTCMonth() + 1, 0); //end of the month date
        var d = d1.setMinutes(d1.getMinutes() - d1.getTimezoneOffset());  //to manage different time zone
        if (minDate > validationDate || maxDate < d) {
          validationMessages.push('Reports do not completely cover date interval');
          break;
        }
      }
    } else if (this.state.approvalTimeIntervalType === 'trimester') {
      const sortedObj = {};
      reportsFiltered.forEach(e => {       // loop over all selected reports
        const k = e.start.slice(0, 4);     // key in YYYY
        let fk;
        if(new Date (e.start).getUTCMonth()<=2){
          fk = `${k}-firstTrimester`;     //key with appended semester
        }
        else if (new Date (e.start).getUTCMonth() <= 5){
          fk = `${k}-secondTrimester`;    //key with appended semester
        } 
        else if (new Date (e.start).getUTCMonth() <= 8){
          fk = `${k}-thirdTrimester`;     //key with appended semester
        } 
        else if (new Date (e.start).getUTCMonth() <= 11){
          fk = `${k}-fourthTrimester`;    //key with appended semester
        } 
        sortedObj[fk] = sortedObj[fk] || []; // create new entry if no value for key exists
        sortedObj[fk].push(e);               // add key to existing list
      });


      const sortedArr = Object.entries(sortedObj); 
      var checkTrimesterMonth = false; //RITM1510731
      var checkTrimesterMonths = false; //RITM1510731
      for (var i = 0; i < sortedArr.length; i++) {
        var minDate = Math.min(...sortedArr[i][1].map((e) => new Date(e.start)));
        var maxDate = Math.max(...sortedArr[i][1].map((e) => new Date(e.end)));

        if(new Date (sortedArr[i][1][0].start).getUTCMonth()<=2){
          validationDate=new Date(sortedArr[i][1][0].start.slice(0, 4) + "-01-01");
        }
        else if (new Date (sortedArr[i][1][0].start).getUTCMonth() <= 5){
          validationDate= new Date(sortedArr[i][1][0].start.slice(0, 4) + "-04-01");
        } 
        else if (new Date (sortedArr[i][1][0].start).getUTCMonth() <= 8){
          validationDate= new Date( sortedArr[i][1][0].start.slice(0, 4) + "-07-01");
        } 
        else if (new Date (sortedArr[i][1][0].start).getUTCMonth() <= 11){
          validationDate= new Date(sortedArr[i][1][0].start.slice(0, 4) + "-10-01");
        } 
        var d1 = new Date(validationDate.getUTCFullYear(), validationDate.getUTCMonth() + 3, 0);  //end of trimester date
        var d = d1.setMinutes(d1.getMinutes() - d1.getTimezoneOffset());  //to manage different time zone
        if (minDate > validationDate || maxDate < d) {
          //RITM1510731
          if (!checkTrimesterMonth) {
              const sortedObj = {};
              sortedArr[i][1].forEach(e => {       // loop over all selected reports
                const k = e.start.slice(0, 7);       // key in YYYY-MM (e.g. 2019-10)
                const fk = `${k}-01`;                // key with appended '-01'   
                sortedObj[fk] = sortedObj[fk] || []; // create new entry if no value for key exists
                sortedObj[fk].push(e);               // add key to existing list
            });
            const sortedMonthTrimesterArr = Object.entries(sortedObj).sort((a, b) => new Date(a[0]) - new Date(b[0]));

            for (var j = 0; j < sortedMonthTrimesterArr.length; j++) {
              var minDate = Math.min(...sortedMonthTrimesterArr[j][1].map((e) => new Date(e.start)));
              var maxDate = Math.max(...sortedMonthTrimesterArr[j][1].map((e) => new Date(e.end)));
              
              var validationDate = new Date(sortedMonthTrimesterArr[j][0]) //start of the month date
              var d1 = new Date(validationDate.getUTCFullYear(), validationDate.getUTCMonth() + 1, 0); //end of the month date
              var d = d1.setMinutes(d1.getMinutes() - d1.getTimezoneOffset());  //to manage different time zone
              if (minDate > validationDate || maxDate < d) {
                validationMessages.push('Reports do not completely cover date interval');
                break;
              }
            }
            checkTrimesterMonth = checkTrimesterMonths = !checkTrimesterMonth ? !checkTrimesterMonth : checkTrimesterMonth;
          }
          else {
            validationMessages.push('The reports belong to different quarters');
            break;
          }
          //End
        }
        //RITM1510731
        else {
          const elements = sortedArr[i][1].map((elem) =>({startDate: elem.start, endDate: elem.end}));
          const trimesterMonths = [];
          elements.forEach(e => { 
            const months = this.getTrimesterMonths(e.startDate, e.endDate);
            trimesterMonths.push(...months)
          });
          const distinctTrimesterMonths = [...new Set(trimesterMonths)];
          var quarter = "";

          if (sortedArr[i][0].includes("firstTrimester")) {
            quarter = "Q1";
          }
          else if (sortedArr[i][0].includes("secondTrimester")) {
            quarter = "Q2";
          }
          else if (sortedArr[i][0].includes("thirdTrimester")) {
            quarter = "Q3";
          }
          else if (sortedArr[i][0].includes("fourthTrimester")) {
            quarter = "Q4";
          }

          const quarterMonths_ = quarterMonths[quarter];

          if (!quarterMonths_.every(m => distinctTrimesterMonths.includes(m))) {
            validationMessages.push('Reports do not completely cover date interval');
            break;
          }

          const sortedObj = {};
              sortedArr[i][1].forEach(e => {       // loop over all selected reports
                const k = e.start.slice(0, 7);       // key in YYYY-MM (e.g. 2019-10)
                const fk = `${k}-01`;                // key with appended '-01'   
                sortedObj[fk] = sortedObj[fk] || []; // create new entry if no value for key exists
                sortedObj[fk].push(e);               // add key to existing list
            });
          const sortedMonthTrimesterArr = Object.entries(sortedObj).sort((a, b) => new Date(a[0]) - new Date(b[0]));

          for (var j = 0; j < sortedMonthTrimesterArr.length; j++) {
            var minDate = Math.min(...sortedMonthTrimesterArr[j][1].map((e) => new Date(e.start)));
            var maxDate = Math.max(...sortedMonthTrimesterArr[j][1].map((e) => new Date(e.end)));
            
            var validationDate = new Date(sortedMonthTrimesterArr[j][0]) //start of the month date
            var d1 = new Date(validationDate.getUTCFullYear(), validationDate.getUTCMonth() + 1, 0); //end of the month date
            var d = d1.setMinutes(d1.getMinutes() - d1.getTimezoneOffset());  //to manage different time zone
            if (minDate > validationDate || maxDate < d) {
              validationMessages.push('Reports do not completely cover date interval');
              break;
            }
          }
            
          if (checkTrimesterMonth && checkTrimesterMonths) {
            validationMessages.push('The reports belong to different quarters');
            break;
          }
          
          checkTrimesterMonth = !checkTrimesterMonth ? !checkTrimesterMonth : checkTrimesterMonth;
        }
        //End
      }
    }
    this.setState({
      approvalValidationMessages: validationMessages,
    });
    return validationMessages.length === 0;
  };

  //RITM1510731
  getTrimesterMonths = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);

    const months = [];
    const current = new Date(start.getFullYear(), start.getMonth(), 1);

    while (current <= end) {
      months.push(current.getMonth());
      current.setMonth(current.getMonth() + 1);
    }

    return months;
  }
  //End

  handleConfirmApprovalModal = () => {
    if (!this.validateApproval(this.state.approvalValidationEnabled)) {
      return;
    }

    const action = this.state.approvalModalAction.toLowerCase();
    const apiEndpoint = this.state.approvalEndpoint;
    const data = {
      ids: this.state.selectedData.map((r) => r.id),
      owner: this.state.approver,
      workflowNotes: this.state.approvalNotes,
      month: this.state.approvalTimeIntervalType === 'month' ? this.state.month : 0,
      trimester: this.state.approvalTimeIntervalType === 'trimester' ? this.state.trimester : 0,
      year: this.state.year,
    };
    this.setState({
      isLoadingWFOperation: true,
    });
    api
      .put(`/reports/${apiEndpoint}/`, data, '')
      .then((response) => {
        if (response.status === 200) {
          this.getReportSummary();
          this.clearApprovalForm();
          this.handleCloseApprovalModal();
          this.setState({
            isLoadingWFOperation: false,
          });
          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            getSuccess(entitiesLabels.REPORT, apioperation.PUT)
          );
        } else {
          showNotification.error();
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.REPORT, apioperation.PUT)
        );
        this.setState({
          isLoadingWFOperation: false,
        });
      });
  };

  clearApprovalForm = () => {
    this.setState({
      approvalStartDate: null,
      approvalEndDate: null,
      approver: null,
      approvalValidationMessages: [],
      approvalValidationEnabled: false,
    });
  };

  showDivInfo = () => {
    this.setState((oldState) => ({ isOpenInfo: !oldState.isOpenInfo }));
  };

  showDivInfoDetail = () => {
    this.setState((oldState) => ({ isOpenInfoDetail: !oldState.isOpenInfoDetail }));
  };

  toggleDivCreateReport = () => {
    this.setState((oldState) => ({ isReportFormOpen: !oldState.isReportFormOpen }));
    this.clearNewReportForm();
    this.setState({
      validationMessages: [],
    });
  };

  renderLoadingModal = () => {
    const show = this.state.isSubmitted;
    return show && <Loading active withOverlay description="Saving..." />;
  };

  divFormReport = () => (
    <div className="bx--modal bx--modal-tall is-visible">
      <div className="bx--modal-container">
        <div className="bx--modal-header">
          <h3 className="bx--modal-header__heading"> Add new Report </h3>{' '}
        </div>
        <div className="bx--row">
          <div className="bx--col-lg-12 bx--col-md-4">
            <FormLabel className="some-class">Discipline</FormLabel>
            {this.state.isLoadingOptions ? (
              <DropdownSkeleton />
            ) : (
              <ComboBox
                id="disciplineOptions"
                className="description-information-left "
                placeholder="Discipline"
                items={this.state.disciplineOptions}
                itemToString={(item) => (item ? item.name : '')}
                itemToElement={(item) => (item ? `${item.name} ` : '')}
                onChange={({ selectedItem }) => this.handleDisciplineChange(selectedItem)}
              />
            )}
          </div>
        </div>
        <div className="bx--row info---table-compact">
          <div className="bx--col-lg-6 bx--col-md-4">
            <FormLabel className="some-class">Start Date</FormLabel>

            <DateTimePicker
              value={this.state.newReportStart}
              type="date"
              placeholder={DateFormat}
              name="startDate"
              onChange={this.handleStartDateChange}
            />
          </div>
          <div className="bx--col-lg-6 bx--col-md-4">
            <FormLabel className="some-class">End Date</FormLabel>

            <DateTimePicker
              value={this.state.newReportEnd}
              type="date"
              placeholder={DateFormat}
              name="endDate"
              onChange={this.handleEndDateChange}
            />
          </div>
        </div>
        <div className="bx--row validation-row">
          <div className="bx--col">
            <ul>
              {this.state.validationMessages.map((e) => (
                <li className="srv-validation-message">{e}</li>
              ))}
            </ul>
          </div>
        </div>
        <div className="searchFormFooter">
          <Button
            className="button--max-width"
            kind="secondary"
            onClick={this.toggleDivCreateReport}
          >
            Cancel
          </Button>

          <Button
            className="button--max-width"
            kind="primary"
            onClick={this.handleCreateReport}
            disabled={this.isCreateButtonDisabled()}
          >
            Create
          </Button>
        </div>
      </div>

      {this.renderLoadingModal()}
    </div>
  );

  divInfo() {
    return (
      this.state.reportSummary && (
        <div className=" box--informations-all">
          <div className="bx--row box--information show">
            <div className="bx--col-lg-12 bx--col-md-10">
              <h5 className="description-page information--detail "> Main Info </h5>
            </div>
            <div className="bx--col-lg-4 bx--col-md-4 ">
              <div className=" information--itmes">
                <div className="information--color ">Worksite:</div>{' '}
                <div className="notification-module">{this.state.reportSummary.workSite}</div>{' '}
              </div>
              <div className="information--itmes">
                <div className="information--color ">Project:</div>{' '}
                <div className="notification-module">{this.state.reportSummary.project}</div>
              </div>
              <div className=" information--itmes">
                <div className="information--color ">Activity:</div>{' '}
                <div className="notification-module">{this.state.reportSummary.activity}</div>{' '}
              </div>
              <div className="information--itmes">
                <div className="information--color ">Country:</div>{' '}
                <div className="notification-module">{this.state.reportSummary.country}</div>
              </div>
              <div className=" information--itmes">
                {/* RITM0945977 */}
                {/* <div className="information--color ">Current worksite division:</div> */}
                <div className="information--color ">Current worksite business line:</div>
                <div className="notification-module">{this.state.reportSummary.division}</div>
              </div>
              <div className=" information--itmes">
                {/* RITM0945977 */}
                {/* <div className="information--color ">Current worksite subdivision:</div> */}
                <div className="information--color ">Current worksite sub-business line:</div>
                <div className="notification-module">{this.state.reportSummary.subDivision}</div>
              </div>
              <div className="information--itmes">
                <div className="information--color "> Overall Prj Worked Manhours: </div>
                {this.state.reportSummary.overallProjectWorkedManhours}
              </div>
            </div>
            <div className="bx--col-lg-4 bx--col-md-4 form--content-group ">
              <div className="information--itmes">
                <div className="information--color ">Operating Company/Branch:</div>
                <div className="notification-module">{this.state.reportSummary.company}</div>
              </div>
              <div className="information--itmes">
                <div className="information--color ">Overall Worksite Worked Manhours:</div>
                {this.state.reportSummary.overallWorksiteWorkedManhours}
              </div>
            </div>
            <div className="bx--col-lg-4 bx--col-md-4 form--content-group">
              <div className="information--itmes information--itmes-mobile">
                <div className="information--color ">Start/End Date:</div>
                <div className="notification-module">
                  {moment.utc(this.state.reportSummary.start).local().format('DD/MM/YYYY')}-
                  {moment.utc(this.state.reportSummary.end).local().format('DD/MM/YYYY')}
                </div>
              </div>
              <div className="information--itmes information--itmes-mobile">
                <div className="information--color ">Prj/Activity Worked Manhours:</div>
                {this.state.reportSummary.prjActivityWorkedManhours}
              </div>
            </div>
          </div>
        </div>
      )
    );
  }

  divInfoDetail() {
    return (
      <div className="bx--row box--information show">
        <div className="bx--col-lg-4 bx--col-md-4 ">
          <div className="information--itmes">
            <div className="information--color ">Country:</div>
            <div className="notification-module"> Kazakhstan </div>
          </div>
          <div className="information--itmes">
            <div className="information--color "> Overall Prj Worked Manhours: </div>0
          </div>
        </div>
        <div className="bx--col-lg-4 bx--col-md-4">
          <div className="information--itmes">
            <div className="information--color ">Operating Company/Branch:</div>
            <div className="notification-module"> ERSAI Caspian Contractor Llc </div>
          </div>
          <div className="information--itmes">
            <div className="information--color ">Overall Worksite Worked Manhours:</div> 0
          </div>
        </div>
        <div className="bx--col-lg-4 bx--col-md-4">
          <div className="information--itmes">
            <div className="information--color ">Reference year:</div>
            <div className="notification-module"> 2019 </div>
          </div>
          <div className="information--itmes">
            <div className="information--color ">Client:</div> #N/A#
          </div>
        </div>
      </div>
    );
  }

  handleDisciplineChange = (selectedItem) => {
    this.setState({
      newReportDiscipline: selectedItem && selectedItem.id,
      newReportDisciplineName: selectedItem && selectedItem.name,
    });
  };

  handleStartDateChange = (inputName, inputValue) => {
    this.setState({ newReportStart: inputValue });
  };

  handleEndDateChange = (inputName, inputValue) => {
    this.setState({ newReportEnd: inputValue });
  };

  isCreateButtonDisabled = () =>
    this.state.newReportDiscipline == null ||
    this.state.newReportStart == null ||
    this.state.newReportEnd == null ||
    this.state.isSubmitted === true;

  clearNewReportForm = () => {
    this.setState({
      newReportStart: null,
      newReportEnd: null,
      newReportDiscipline: null,
      newReportDisciplineName: null,
      validationmessages: [],
    });
  };

  getYearQuarter(date) {
    const month = date.getUTCMonth() + 1;
    return Math.ceil(month / 3);
  }

  handleCreateReport = () => {
    const monthOffset = this.state.newReportDisciplineName === 'Safety' ? 0 : 2;
    // console.log(this.state);
    const validationMessages = [];
    if (new Date(this.state.newReportStart) > new Date(this.state.newReportEnd)) {
      validationMessages.push('Start date must precede end date');
    }
    if (
      new Date(this.state.newReportStart) < new Date(this.state.reportSummary.start) ||
      new Date(this.state.newReportEnd) > new Date(this.state.reportSummary.end)
    ) {
      validationMessages.push('Report period must be within report summary period');
    }
    if (
      new Date(this.state.newReportEnd).getUTCMonth() >
        new Date(this.state.newReportStart).getUTCMonth() + monthOffset ||
      (this.state.newReportDisciplineName === 'Safety'
        ? new Date(this.state.newReportStart).getUTCMonth() !==
          new Date(this.state.newReportEnd).getUTCMonth()
        : this.getYearQuarter(new Date(this.state.newReportStart)) !==
          this.getYearQuarter(new Date(this.state.newReportEnd)))
    ) {
      validationMessages.push(
        `Report period must be within the period related to ${this.state.newReportDisciplineName} discipline`
      );
    }
    if (
      this.state.reportSummary.reports
        .filter((r) => r.discipline === this.state.newReportDisciplineName)
        .some(
          (r) =>
            new Date(r.start) <= new Date(this.state.newReportEnd) &&
            new Date(r.end) >= new Date(this.state.newReportStart)
        )
    ) {
      validationMessages.push(
        `There are already one or more ${this.state.newReportDisciplineName} reports in the specified period`
      );
    }

    this.setState({
      validationMessages,
    });
    if (validationMessages.length > 0) {
      return;
    }
    this.setState({
      isSubmitted: true,
    });
    const newReport = {
      id: uuid(),
      start: this.state.newReportStart,
      end: this.state.newReportEnd,
      idReportDiscipline: this.state.newReportDiscipline,

      idReportSummary: this.props.match.params.idReportSummary,
    };
    api
      .post('reports', newReport)
      .then(async (response) => {
        if (response.status === 200) {
          const summary = this.state.reportSummary;
          newReport.idStatus = 1;
          newReport.status = 'Opened';
          newReport.discipline = this.state.newReportDisciplineName;
          newReport.compiledBy = `${this.context.user.name} ${this.context.user.surname}`;
          summary.reports.push(newReport);
          await ReportRepository.updateCachedReportList(summary);
          await ReportRepository.updateReportDetail(newReport);
          this.setState({
            isLoading: true,
            reportSummary: summary,
          });
          this.getReportSummary();
          this.clearNewReportForm();
          this.setState({
            isReportFormOpen: false,
          });
          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            getSuccess(entitiesLabels.REPORT, apioperation.POST)
          );
        } else {
          showNotification.error();
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.REPORT, apioperation.POST)
        );
      })
      .finally(() => {
        this.setState({
          isSubmitted: false,
        });
      });
  };

  getReportSummary = () => {
    api
      .get('reports/reportsummaries/', this.props.match.params.idReportSummary)
      .then((response) => {
        // response.data.start = moment.utc(response.data.start).local().format("MM/DD/YYYY");
        // response.data.end = moment.utc(response.data.end).local().format("MM/DD/YYYY");
        // response.data.reports.forEach(x => {
        //     x.start = moment.utc(x.start).local().format("MM/DD/YYYY");
        //     x.end = moment.utc(x.end).local().format("MM/DD/YYYY");
        // });
        this.setState({
          reportSummary: response.data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.REPORTSUMMARY, apioperation.GET)
        );
      })
      .finally(() => {
        if(this.state.codeFilter)
        {
          this.setState({
          isLoading: false,
          isOpenFilter:true,
          });
        }else {
        this.setState({
          isLoading: false,
        });
      }
      });
  };

  getDisciplineOptions = () => {
    api
      .getAll(`reports/disciplines/${this.props.match.params.idReportSummary}`)
      .then((response) => {
        this.setState({
          disciplineOptions: response.data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.DISCIPLINE, apioperation.GET)
        );
      })
      .finally(() => {
        this.setState({
          isLoadingOptions: false,
        });
      });
  };

  getUsersInRole = (role, appModule, idWorksite, idDivision, includeDataApprovers = false) => { //RITM1064131
    if (idWorksite || idDivision) { //RITM1064131
      me.getWithParam('getuserbyroleandmodule', { //RITM1064131
        params: { Role: role, appModule: appModule, idWorksites: idWorksite, IdDivision: idDivision, includeAdmins: true, includeDataApprovers: includeDataApprovers }, //RITM1064131
      })
        .then((response) => {
          this.setState({
            approvers: response.data,
            isLoadingApproverOptions: false,
          });
        })
        .catch((error) => {
          showNotification.error(
            `${entitiesLabels.ERROR}`,
            getError(error, entitiesLabels.ROLE, apioperation.POST)
          );
        })
        .finally(() => {
          this.setState({
            isLoadingApproverOptions: false,
          });
        });
    }
  };
  batchActionClick(
    actionKey,
    actionName,
    approverRole,
    withApprover,
    approvalNotesRequired,
    withTimeApproval,
    approvalValidationEnabled,
    selectedRows
  ) {
    const { reportSummary } = this.state;

    const idWorksite =
      actionKey === 'Submit'
        ? reportSummary.idWorkSite
        : null; //RITM1064131
    const idDivision =
      actionKey === 'Approve'
        ? reportSummary.idDivision
        : null; //RITM1064131

    const approvalTimeIntervalType =
      this.state.reportSummary.reports
        .find((i) => i.id === selectedRows[0].id)
        .discipline.toLowerCase() === 'safety'
        ? 'month'
        : 'trimester';

    this.setState({
      approvalModalAction: actionName,
      isApprovalModalOpen: true,
      isLoadingApproverOptions: true,
      selectedData: selectedRows,
      withApprover,
      approverRole,
      approvalEndpoint: actionKey,
      approvalNotesRequired,
      withTimeApproval,
      approvalTimeIntervalType,
      approvalValidationEnabled,
    });

    if (withApprover) this.getUsersInRole(approverRole, 'Report', idWorksite, idDivision); //RITM1064131
  }
  changeCompilerActionClick(selectedRows) {
    const idEntity = this.state.reportSummary.idDivision;

    this.setState({
      isChangeRequestModalOpen: true,
      isLoadingApproverOptions: true,
      selectedData: selectedRows,
    });

    this.getUsersInRole('Administrator', 'Report', null, idEntity); //RITM1064131
  }
  confirmCompilerActionClick(selectedRows) {
    const idEntity = this.state.reportSummary.idWorkSite; //RITM1064131
    const r = this.state.reportSummary.reports.find((el) => el.id === selectedRows[0].id);
    this.setState({
      isConfirmRequestModalOpen: true,
      isLoadingApproverOptions: true,
      selectedData: selectedRows,
      compiler: r.compiler,
    });

    this.getUsersInRole('Compiler', 'Report', idEntity, null, true); //RITM1064131
  }
  confirmChangeCompilerRequest = (idRow, user) => {
    const r = this.state.reportSummary.reports.find((el) => el.id === idRow);
    return r && r.changesRequests != null && r.changesRequests.idUserRequestTo === user.id && r.changesRequests.requestComplete === false ;
  };
  isRequestChangeCompilerPending = (idRow) => {
    const r = this.state.reportSummary.reports.find((el) => el.id === idRow);
    if(r.idCompiler == this.context.user.id || this.context.user.roles.find((role) => role.includes('Administrator')))
      {return (r && r.changesRequests != null ) && r.changesRequests.requestComplete==false;
      }else return true
  };

  isReportCompiler = (idRow) => {
    const r = this.state.reportSummary.reports.find((el) => el.id === idRow);
    if(r.idCompiler == this.context.user.id)
      {return r.compiler
      }else return false
  };
  getStatuses = () => {
    ReportRepository.getStatus()
      .then((response) => {
        this.setState({
          statuses: response,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.STATUS, apioperation.GET)
        );
      })
      .finally(() => {
        this.setState({
          isLoadingOptions: false,
        });
      });
  };

  handleApprovalNotesChange = (e) => {
    this.setState({ approvalNotes: e.target.value });
  };

  componentDidMount() {
    this.getReportSummary();
    this.getDisciplineOptions();
    this.getStatuses();
  }

  getReport = (selectedRows) => {
    if (this.state.reportSummary && this.state.reportSummary.reports) {
      if (selectedRows && selectedRows.length > 0) {
        return this.state.reportSummary.reports.find((el) => el.id === selectedRows[0].id);
      }
    }
    return null;
  };

  getStatusId = (idRow) => {
    const r = this.state.reportSummary.reports.find((el) => el.id === idRow);

    return r && r.idStatus;
  };

  IsRowSelectable(row, selectedRows, user) {
    var row = this.state.reportSummary.reports.find((i) => i.id === row.id);

    if (row.status === 'Consolidated') return false;

    if (selectedRows.length === 0) {
      return true;
    }

    if (selectedRows.length > 0) {
      const selectableReport = this.state.reportSummary.reports.find(
        (i) => i.id === selectedRows[0].id
      );

      const selectableState = selectableReport.idStatus;
      const selectableDiscipline = selectableReport.discipline;

      if (row.idStatus === selectableState && row.discipline === selectableDiscipline) {
        const canSelect =
          CanExecuteAction('Report', 'Reporting', user, row.idStatus, 'Submit', row) ||
          CanExecuteAction('Report', 'Reporting', user, row.idStatus, 'Approve', row) ||
          CanExecuteAction('Report', 'Reporting', user, row.idStatus, 'Consolidate', row) ||
          CanExecuteAction('Report', 'Reporting', user, row.idStatus, 'Reject', row) ||
          CanExecuteAction('Report', 'Reporting', user, row.idStatus, 'RejectConsolidate', row) ||
          CanExecuteAction('Report', 'Reporting', user, row.idStatus, 'Delete', row);
        return canSelect;
        // return true;
      }

      return false;
    }

    return false;
  }

  /** ***********Form Ricerca******************* */
  toggleSearchForm = (e) => {
    // ope and clear filter div
    e.preventDefault();
    this.setState((oldState) => ({
      isOpenFilter: !oldState.isOpenFilter,
      compilerFilter: null,
      dataApproverFilter: null,
      divisionManagerFilter: null,
      // codeFilter: null,
    }));
  };

  handleChangeSearch = (el) => {
    const inputName = el.target.name;
    const inputValue = el.target.value;

    this.setState({ [inputName]: inputValue });
  };

  divFiterReport = () => (
    <div className="bx--row">
      <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-6">
        <FormLabel>Report Code</FormLabel>
        <TextInput
          id="inputsearchCode"
          name="codeFilter"
          value={this.state.codeFilter || ''}
          onChange={this.handleChangeSearch}
          placeholder="Input Report Code"
          type="text"
          labelText=""
          className="bx--text-input some-class bx--text-input--light"
        />
      </FormGroup>

      <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-6">
        <FormLabel>Email Compiler</FormLabel>
        <TextInput
          id="inputsearchcompiler"
          name="compilerFilter"
          value={this.state.compilerFilter || ''}
          onChange={this.handleChangeSearch}
          placeholder="Input Compiler"
          type="text"
          labelText=""
          className="bx--text-input some-class bx--text-input--light"
        />
      </FormGroup>

      <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-6">
        <FormLabel>Email Data Approver</FormLabel>
        <TextInput
          id="inputsearchdataApprover"
          name="dataApproverFilter"
          value={this.state.dataApproverFilter || ''}
          onChange={this.handleChangeSearch}
          placeholder="Input Data Approver"
          type="text"
          labelText=""
          className="bx--text-input some-class bx--text-input--light"
        />
      </FormGroup>

      <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-6">
        <FormLabel>Email Consolidator</FormLabel>
        <TextInput
          id="inputsearchdivisionManager"
          name="divisionManagerFilter"
          value={this.state.divisionManagerFilter || ''}
          onChange={this.handleChangeSearch}
          placeholder="Input Consolidator"
          type="text"
          labelText=""
          className="bx--text-input some-class bx--text-input--light"
        />
      </FormGroup>
    </div>
  );

  buildFilter = (reports) => {
    let filtered = reports;

    filtered = this.state.compilerFilter
      ? filtered.filter((item) => item.compiler?.includes(this.state.compilerFilter))
      : filtered;

    filtered = this.state.dataApproverFilter
      ? filtered.filter((item) => item.dataApprover?.includes(this.state.dataApproverFilter))
      : filtered;

    filtered = this.state.divisionManagerFilter
      ? filtered.filter((item) => item.divisionManager?.includes(this.state.divisionManagerFilter))
      : filtered;

    filtered = this.state.codeFilter
      ? filtered.filter((item) => item.reportCode?.includes(this.state.codeFilter))
      : filtered;
    return filtered;
  };

  render() {
    const headersDataTable = [
      { key: 'reportCode', header: 'Code ' },
      { key: 'start', header: 'Start Date ', type: 'date' },
      { key: 'end', header: 'End Date ', type: 'date' },

      { key: 'status', header: 'Status', type: 'status' },
    ];

    const reports =
      this.state.reportSummary &&
      this.buildFilter(this.state.reportSummary.reports.map((r) => ({ ...r })));
      
    /*  reports && reports.forEach(x => {
              x.start = moment.utc(x.start).local().format("DD/MM/YYYY");
              x.end = moment.utc(x.end).local().format("DD/MM/YYYY");
          }) */
    const skeletonRowCount =
      this.state.rowCount > 0 && this.state.pageSize > this.state.rowCount
        ? this.state.rowCount
        : this.state.pageSize;
    return (
      <AppContext.Consumer>
        {({ user }) => (
          <>
            <PageBreadCrumb
              linkTo="/reportSummaries?isBack"
              linkText="Report Summary"
              titleLeft="Report Summary"
              titleCenter={
                this.state.reportSummary && `ID: ${this.state.reportSummary.progressiveId}`
              }
            />
            <div className="mainContainer">
              <div className="bx--grid content full-width mainContainer ">
                {this.state.isLoading ? (
                  <CodeSnippetSkeleton type="multi" />
                ) : (
                  <>{this.divInfo()}</>
                )}

                <div className="bx--row description-big-title info---table-compact ">
                  <div className=" table-compact-detail bx--col-  ">
                    <TableToolbar>
                      <h5 className="description-page info---table-compact-detail  table-toolbar-content-mobile">
                        {' '}
                        Available report(s){' '}
                      </h5>
                      <Button
                        onClick={this.toggleSearchForm}
                        className="buttonPaddingIcon"
                        renderIcon={Data16}
                        iconDescription="Filter"
                      />

                      {IsInRole(user, 'Administrator') || IsInRole(user, 'Compiler') || IsInRole(user, 'Data Approver') ? ( //RITM1064131
                        <Button
                          className="some-class"
                          size="default"
                          renderIcon={Add16}
                          iconDescription="new report"
                          tooltipPosition="top"
                          tooltipAlignment="center"
                          onClick={this.toggleDivCreateReport}
                          hasIconOnly
                        />
                      ) : null}
                    </TableToolbar>
                  </div>
                </div>
                <Tabs
                  ariaLabel="listbox"
                  className="auditReportTab"
                  iconDescription="show menu options"
                  onKeyDown={() => {}}
                  role="navigation"
                  selected={0}
                  tabContentClassName="auditReportTab"
                  triggerHref="#"
                  type="default"
                >
                  <Tab
                    href="#"
                    label="Safety"
                    onClick={() => {}}
                    onKeyDown={() => {}}
                    role="presentation"
                    selected={false}
                    tabIndex={0}
                  >
                    {' '}
                    {this.state.isOpenFilter && this.divFiterReport()}
                    <DataTable
                      rows={(reports || []).filter((el) => el.discipline === 'Safety')}
                      headers={headersDataTable}
                      useZebraStyles
                      size="compact"
                      render={({
                        rows,
                        headers,
                        getHeaderProps,
                        getRowProps,
                        getSelectionProps,
                        selectedRows,
                        getBatchActionProps,
                      }) => (
                        <TableContainer className="bx--grid-full-width">
                          {selectedRows.length > 0 ? (
                            <TableToolbar>
                              <TableToolbarContent>
                                <Online>
                                  <TableBatchActions {...getBatchActionProps()}>
                                    {CanExecuteAction(
                                      'Report',
                                      'Reporting',
                                      user,
                                      selectedRows.length > 0
                                        ? this.getStatusId(selectedRows[0].id)
                                        : null,
                                      'Submit',
                                      this.getReport(selectedRows)
                                    ) ? (
                                      <TableBatchAction
                                        renderIcon={Send16}
                                        onClick={() =>
                                          this.batchActionClick(
                                            'Submit',
                                            'Submit',
                                            'Data Approver',
                                            true,
                                            false,
                                            true,
                                            true,
                                            selectedRows
                                          )
                                        }
                                      >
                                        Submit Report
                                      </TableBatchAction>
                                    ) : null}

                                    {CanExecuteAction(
                                      'Report',
                                      'Reporting',
                                      user,
                                      selectedRows.length > 0
                                        ? this.getStatusId(selectedRows[0].id)
                                        : null,
                                      'Approve',
                                      this.getReport(selectedRows)
                                    ) ? (
                                      <TableBatchAction
                                        renderIcon={CheckmarkOutline16}
                                        onClick={() =>
                                          this.batchActionClick(
                                            'Approve',
                                            'Approve',
                                            'Division Manager',
                                            true,
                                            false,
                                            true,
                                            true,
                                            selectedRows
                                          )
                                        }
                                      >
                                        Approve Report
                                      </TableBatchAction>
                                    ) : null}

                                    {CanExecuteAction(
                                      'Report',
                                      'Reporting',
                                      user,
                                      selectedRows.length > 0
                                        ? this.getStatusId(selectedRows[0].id)
                                        : null,
                                      'Consolidate',
                                      this.getReport(selectedRows)
                                    ) ? (
                                      <TableBatchAction
                                        renderIcon={CheckmarkOutline16}
                                        onClick={() =>
                                          this.batchActionClick(
                                            'Consolidate',
                                            'Approve',
                                            null,
                                            false,
                                            false,
                                            true,
                                            true,
                                            selectedRows
                                          )
                                        }
                                      >
                                        Approve Report
                                      </TableBatchAction>
                                    ) : null}

                                    {CanExecuteAction(
                                      'Report',
                                      'Reporting',
                                      user,
                                      selectedRows.length > 0
                                        ? this.getStatusId(selectedRows[0].id)
                                        : null,
                                      'Reject',
                                      this.getReport(selectedRows)
                                    ) ? (
                                      <TableBatchAction
                                        renderIcon={Error16}
                                        onClick={() =>
                                          this.batchActionClick(
                                            'Reject',
                                            'Reject',
                                            null,
                                            false,
                                            true,
                                            true,
                                            true,
                                            selectedRows
                                          )
                                        }
                                      >
                                        Reject Report
                                      </TableBatchAction>
                                    ) : null}

                                    {CanExecuteAction(
                                      'Report',
                                      'Reporting',
                                      user,
                                      selectedRows.length > 0
                                        ? this.getStatusId(selectedRows[0].id)
                                        : null,
                                      'RejectConsolidate',
                                      this.getReport(selectedRows)
                                    ) ? (
                                      <TableBatchAction
                                        renderIcon={Error16}
                                        onClick={() =>
                                          this.batchActionClick(
                                            'RejectConsolidate',
                                            'Reject',
                                            null,
                                            false,
                                            true,
                                            true,
                                            true,
                                            selectedRows
                                          )
                                        }
                                      >
                                        Reject Report
                                      </TableBatchAction>
                                    ) : null}

                                    {CanExecuteAction(
                                      'Report',
                                      'Reporting',
                                      user,
                                      selectedRows.length > 0
                                        ? this.getStatusId(selectedRows[0].id)
                                        : null,
                                      'Delete',
                                      this.getReport(selectedRows)
                                    ) ? (
                                      <TableBatchAction
                                        renderIcon={Delete16}
                                        onClick={() =>
                                          this.batchActionClick(
                                            'Delete',
                                            'Delete',
                                            null,
                                            false,
                                            false,
                                            false,
                                            false,
                                            selectedRows
                                          )
                                        }
                                      >
                                        Delete Report
                                      </TableBatchAction>
                                    ) : null}
                                  </TableBatchActions>
                                </Online>
                              </TableToolbarContent>
                            </TableToolbar>
                          ) : (
                            ''
                          )}

                 
                  <ChangeCompilerModal
                    show={this.state.isChangeRequestModalOpen}
                    title="Change Compiler"
                    action={this.state.approvalModalAction}
                    withApprover={this.state.withApprover}
                    approver={this.state.approver}
                    approverRole={this.state.approverRole}
                    approverOptions={this.state.approvers}
                    isLoadingOperation={this.state.isLoadingWFOperation}
                    onApproverSelect={this.handleApproverSelect}
                    isLoadingOptions={this.state.isLoadingApproverOptions}
                    onCancel={this.handleCloseChangeCompilerModal}
                    onConfirm={this.handleChangeCompilerModal}
                    onApprovalNotesChange={this.handleApprovalNotesChange}
                    approvalNotes={this.state.approvalNotes}
                    approvalNotesRequired={this.state.approvalNotesRequired}
                    validationMessages={this.state.approvalValidationMessages}
                  />

                  <ConfirmCompilerModal
                    show={this.state.isConfirmRequestModalOpen}
                    title="Change Report Compiler"
                    action={this.state.approvalModalAction}
                    withApprover={this.state.withApprover}
                    approver={this.state.approver}
                    approverRole={this.state.approverRole}
                    approverOptions={this.state.approvers}
                    isLoadingOperation={this.state.isLoadingWFOperation}
                    onApproverSelect={this.handleApproverSelect}
                    isLoadingOptions={this.state.isLoadingApproverOptions}
                    onCancel={this.handleCloseConfirmCompilerModal}
                    onConfirm={this.handleConfirmCompilerModal}
                    compiler={this.state.compiler}
                    onApprovalNotesChange={this.handleApprovalNotesChange}
                    approvalNotes={this.state.approvalNotes}
                    approvalNotesRequired={this.state.approvalNotesRequired}
                    validationMessages={this.state.approvalValidationMessages}
                  />
                          {this.state.isLoading ? (
                            <DataTableSkeleton
                              headers={[]}
                              rowCount={skeletonRowCount}
                              zebra={false}
                              compact={false}
                            />
                          ) : (
                            <Table className="">
                              <TableHead className="colorgray">
                                <TableRow>
                                  <TableHeader className="align-center" />
                                  {headers.map((header) => (
                                    <TableHeader
                                      className={header.type === 'bool' ? 'align-center' : ''}
                                      {...getHeaderProps({ header })}
                                    >
                                      {header.header}
                                    </TableHeader>
                                  ))}
                                  <TableHeader className="align-center">Actions</TableHeader>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {rows == null || rows.length === 0 ? (
                                  <NoRecordsPlaceholder colSpan={headers.length + 2} />
                                ) : (
                                  rows.map((row) => (
                                    <TableRow {...getRowProps({ row })}>
                                      <Online>
                                        {this.IsRowSelectable(row, selectedRows, user) ? (
                                          <TableSelectRow {...getSelectionProps({ row })} />
                                        ) : (
                                          <TableCell
                                            key={`empty${row.id}`}
                                            className="tableActions align-center"
                                          />
                                        )}
                                      </Online>
                                      <Offline>
                                        {this.IsRowSelectable(row, selectedRows, user) ? (
                                          <TableSelectRow
                                            {...getSelectionProps({ row })}
                                            disabled
                                          />
                                        ) : (
                                          <TableCell
                                            key={`empty${row.id}`}
                                            className="tableActions align-center"
                                          />
                                        )}
                                      </Offline>
                                      {row.cells.map((cell) => (
                                        <RenderDataTableCell
                                          key={cell.id}
                                          cell={cell}
                                          header={headers.find((x) => x.key === cell.info.header)}
                                        />
                                      ))}

                                      <TableCell
                                        key={`action-${row.id}`}
                                        className="tableActions align-center"
                                      >
                                        <div>
                                          <Link
                                            to={`/reportSummaries/${this.state.reportSummary.id}/${
                                              this.state.reportSummary.reports.find(
                                                (r) => r.id === row.id
                                              ).discipline
                                            }/${row.id}`}
                                          >
                                            <Button
                                              size="small"
                                              renderIcon={Edit16}
                                              iconDescription="Edit"
                                              kind="ghost"
                                            />
                                          </Link>
                                          <Online>
                                          {this.confirmChangeCompilerRequest(row.id, user) &&
                                            IsInRole(user, 'Administrator') && (
                                              <Button
                                              onClick={() => this.confirmCompilerActionClick([].concat(row))}
                                                size="small"
                                                renderIcon={UserAdmin16}
                                                title="Confirm New Compiler"
                                                iconDescription="Confirm New Compiler"
                                                kind="ghost"
                                              />
                                            )}
                                          { !this.isRequestChangeCompilerPending(row.id) &&(
                                              <Button
                                                onClick={() => this.changeCompilerActionClick([].concat(row))}
                                                size="small"
                                                renderIcon={Collaborate16}
                                                title="Request Change Compiler"
                                                iconDescription="Request Change Compiler"
                                                kind="ghost"
                                              />                                             
                                            )}
                                              {this.isRequestChangeCompilerPending(row.id) &&
                                              this.isReportCompiler(row.id) &&
                                              !this.confirmChangeCompilerRequest(row.id, user) &&
                                              (
                                              <Button
                                                onClick={() => this.changeCompilerActionClick([].concat(row))}
                                                size="small"
                                                renderIcon={Collaborate16}
                                                title="Request Pending"
                                                iconDescription="Request Pending"
                                                kind="ghost"
                                                disabled={true}
                                              />                                             
                                            )}
                                        </Online>                                        
                                        </div>
                                      </TableCell>
                                    </TableRow>
                                  ))
                                )}
                              </TableBody>
                            </Table>
                          )}
                        </TableContainer>
                      )}
                    />
                  </Tab>
                  <Tab
                    href="#"
                    label="Environment"
                    onClick={() => {}}
                    onKeyDown={() => {}}
                    role="presentation"
                    selected={false}
                    tabIndex={0}
                  >
                    {' '}
                    {this.state.isOpenFilter && this.divFiterReport()}
                    <DataTable
                      rows={(reports || []).filter((el) => el.discipline === 'Environment')}
                      headers={headersDataTable}
                      useZebraStyles
                      size="compact"
                      render={({
                        rows,
                        headers,
                        getHeaderProps,
                        getRowProps,
                        getSelectionProps,
                        selectedRows,
                        getBatchActionProps,
                      }) => (
                        <TableContainer className="bx--grid-full-width">
                          {selectedRows.length > 0 ? (
                            <TableToolbar>
                              <TableToolbarContent>
                                <Online>
                                  <TableBatchActions {...getBatchActionProps()}>
                                    {CanExecuteAction(
                                      'Report',
                                      'Reporting',
                                      user,
                                      selectedRows.length > 0
                                        ? this.getStatusId(selectedRows[0].id)
                                        : null,
                                      'Submit',
                                      this.getReport(selectedRows)
                                    ) ? (
                                      <TableBatchAction
                                        renderIcon={Send16}
                                        onClick={() =>
                                          this.batchActionClick(
                                            'Submit',
                                            'Submit',
                                            'Data Approver',
                                            true,
                                            false,
                                            true,
                                            true,
                                            selectedRows
                                          )
                                        }
                                      >
                                        Submit Report
                                      </TableBatchAction>
                                    ) : null}

                                    {CanExecuteAction(
                                      'Report',
                                      'Reporting',
                                      user,
                                      selectedRows.length > 0
                                        ? this.getStatusId(selectedRows[0].id)
                                        : null,
                                      'Approve',
                                      this.getReport(selectedRows)
                                    ) ? (
                                      <TableBatchAction
                                        renderIcon={CheckmarkOutline16}
                                        onClick={() =>
                                          this.batchActionClick(
                                            'Approve',
                                            'Approve',
                                            'Division Manager',
                                            true,
                                            false,
                                            true,
                                            true,
                                            selectedRows
                                          )
                                        }
                                      >
                                        Approve Report
                                      </TableBatchAction>
                                    ) : null}

                                    {CanExecuteAction(
                                      'Report',
                                      'Reporting',
                                      user,
                                      selectedRows.length > 0
                                        ? this.getStatusId(selectedRows[0].id)
                                        : null,
                                      'Consolidate',
                                      this.getReport(selectedRows)
                                    ) ? (
                                      <TableBatchAction
                                        renderIcon={CheckmarkOutline16}
                                        onClick={() =>
                                          this.batchActionClick(
                                            'Consolidate',
                                            'Approve',
                                            null,
                                            false,
                                            false,
                                            true,
                                            true,
                                            selectedRows
                                          )
                                        }
                                      >
                                        Approve Report
                                      </TableBatchAction>
                                    ) : null}

                                    {CanExecuteAction(
                                      'Report',
                                      'Reporting',
                                      user,
                                      selectedRows.length > 0
                                        ? this.getStatusId(selectedRows[0].id)
                                        : null,
                                      'Reject',
                                      this.getReport(selectedRows)
                                    ) ? (
                                      <TableBatchAction
                                        renderIcon={Error16}
                                        onClick={() =>
                                          this.batchActionClick(
                                            'Reject',
                                            'Reject',
                                            null,
                                            false,
                                            true,
                                            true,
                                            true,
                                            selectedRows
                                          )
                                        }
                                      >
                                        Reject Report
                                      </TableBatchAction>
                                    ) : null}

                                    {CanExecuteAction(
                                      'Report',
                                      'Reporting',
                                      user,
                                      selectedRows.length > 0
                                        ? this.getStatusId(selectedRows[0].id)
                                        : null,
                                      'RejectConsolidate',
                                      this.getReport(selectedRows)
                                    ) ? (
                                      <TableBatchAction
                                        renderIcon={Error16}
                                        onClick={() =>
                                          this.batchActionClick(
                                            'RejectConsolidate',
                                            'Reject',
                                            null,
                                            false,
                                            true,
                                            true,
                                            true,
                                            selectedRows
                                          )
                                        }
                                      >
                                        Reject Report
                                      </TableBatchAction>
                                    ) : null}

                                    {CanExecuteAction(
                                      'Report',
                                      'Reporting',
                                      user,
                                      selectedRows.length > 0
                                        ? this.getStatusId(selectedRows[0].id)
                                        : null,
                                      'Delete',
                                      this.getReport(selectedRows)
                                    ) ? (
                                      <TableBatchAction
                                        renderIcon={Delete16}
                                        onClick={() =>
                                          this.batchActionClick(
                                            'Delete',
                                            'Delete',
                                            null,
                                            false,
                                            false,
                                            false,
                                            false,
                                            selectedRows
                                          )
                                        }
                                      >
                                        Delete Report
                                      </TableBatchAction>
                                    ) : null}
                                  </TableBatchActions>
                                </Online>
                              </TableToolbarContent>
                            </TableToolbar>
                          ) : (
                            ''
                          )}
                             
                    <ChangeCompilerModal
                    show={this.state.isChangeRequestModalOpen}
                    title="Change Compiler"
                    action={this.state.approvalModalAction}
                    withApprover={this.state.withApprover}
                    approver={this.state.approver}
                    approverRole={this.state.approverRole}
                    approverOptions={this.state.approvers}
                    isLoadingOperation={this.state.isLoadingWFOperation}
                    onApproverSelect={this.handleApproverSelect}
                    isLoadingOptions={this.state.isLoadingApproverOptions}
                    onCancel={this.handleCloseChangeCompilerModal}
                    onConfirm={this.handleChangeCompilerModal}
                    onApprovalNotesChange={this.handleApprovalNotesChange}
                    approvalNotes={this.state.approvalNotes}
                    approvalNotesRequired={this.state.approvalNotesRequired}
                    validationMessages={this.state.approvalValidationMessages}
                  />

                  <ConfirmCompilerModal
                    show={this.state.isConfirmRequestModalOpen}
                    title="Change Report Compiler"
                    action={this.state.approvalModalAction}
                    withApprover={this.state.withApprover}
                    approver={this.state.approver}
                    approverRole={this.state.approverRole}
                    approverOptions={this.state.approvers}
                    isLoadingOperation={this.state.isLoadingWFOperation}
                    onApproverSelect={this.handleApproverSelect}
                    isLoadingOptions={this.state.isLoadingApproverOptions}
                    onCancel={this.handleCloseConfirmCompilerModal}
                    onConfirm={this.handleConfirmCompilerModal}
                    compiler={this.state.compiler} //RITM1064131
                    onApprovalNotesChange={this.handleApprovalNotesChange}
                    approvalNotes={this.state.approvalNotes}
                    approvalNotesRequired={this.state.approvalNotesRequired}
                    validationMessages={this.state.approvalValidationMessages}
                  />
                          {this.state.isLoading ? (
                            <DataTableSkeleton
                              headers={[]}
                              rowCount={skeletonRowCount}
                              zebra={false}
                              compact={false}
                            />
                          ) : (
                            <Table className="">
                              <TableHead className="colorgray">
                                <TableRow>
                                  <TableHeader className="align-center" />
                                  {headers.map((header) => (
                                    <TableHeader
                                      className={header.type === 'bool' ? 'align-center' : ''}
                                      {...getHeaderProps({ header })}
                                    >
                                      {header.header}
                                    </TableHeader>
                                  ))}
                                  <TableHeader className="align-center">Actions</TableHeader>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {rows == null || rows.length === 0 ? (
                                  <NoRecordsPlaceholder colSpan={headers.length + 2} />
                                ) : (
                                  rows.map((row) => (
                                    <TableRow {...getRowProps({ row })}>
                                      <Online>
                                        {this.IsRowSelectable(row, selectedRows, user) ? (
                                          <TableSelectRow {...getSelectionProps({ row })} />
                                        ) : (
                                          <TableCell
                                            key={`empty${row.id}`}
                                            className="tableActions align-center"
                                          />
                                        )}
                                      </Online>
                                      <Offline>
                                        {this.IsRowSelectable(row, selectedRows, user) ? (
                                          <TableSelectRow
                                            {...getSelectionProps({ row })}
                                            disabled
                                          />
                                        ) : (
                                          <TableCell
                                            key={`empty${row.id}`}
                                            className="tableActions align-center"
                                          />
                                        )}
                                      </Offline>
                                      {row.cells.map((cell) => (
                                        <RenderDataTableCell
                                          key={cell.id}
                                          cell={cell}
                                          header={headers.find((x) => x.key === cell.info.header)}
                                        />
                                      ))}

                                      <TableCell
                                        key={`action-${row.id}`}
                                        className="tableActions align-center"
                                      >
                                        <div>
                                          <Link
                                            to={`/reportSummaries/${this.state.reportSummary.id}/${
                                              this.state.reportSummary.reports.find(
                                                (r) => r.id === row.id
                                              ).discipline
                                            }/${row.id}`}
                                          >
                                            <Button
                                              size="small"
                                              renderIcon={Edit16}
                                              iconDescription="Edit"
                                              kind="ghost"
                                            />
                                          </Link>
                                          <Online>
                                          {this.confirmChangeCompilerRequest(row.id, user) &&
                                            IsInRole(user, 'Administrator') && (
                                              <Button
                                              onClick={() => this.confirmCompilerActionClick([].concat(row))}
                                                size="small"
                                                renderIcon={UserAdmin16}
                                                title="Confirm New Compiler"
                                                iconDescription="Confirm New Compiler"
                                                kind="ghost"
                                              />
                                            )}
                                          { !this.isRequestChangeCompilerPending(row.id) && (
                                              <Button
                                                onClick={() => this.changeCompilerActionClick([].concat(row))}
                                                size="small"
                                                renderIcon={Collaborate16}
                                                title="Request Change Compiler"
                                                iconDescription="Request Change Compiler"
                                                kind="ghost"
                                              />
                                            )}
                                             {this.isRequestChangeCompilerPending(row.id) &&
                                              this.isReportCompiler(row.id) &&
                                              !this.confirmChangeCompilerRequest(row.id, user) &&
                                              (
                                              <Button
                                                onClick={() => this.changeCompilerActionClick([].concat(row))}
                                                size="small"
                                                renderIcon={Collaborate16}
                                                title="Request Pending"
                                                iconDescription="Request Pending"
                                                kind="ghost"
                                                disabled={true}
                                              />                                             
                                            )}
                                        </Online>   
                                        </div>
                                      </TableCell>
                                    </TableRow>
                                  ))
                                )}
                              </TableBody>
                            </Table>
                          )}
                        </TableContainer>
                      )}
                    />
                  </Tab>
{/*                   <Tab
                    href="#"
                    label="Asset Integrity"
                    onClick={() => {}}
                    onKeyDown={() => {}}
                    role="presentation"
                    selected={false}
                    tabIndex={0}
                  >
                    {' '}
                    {this.state.isOpenFilter && this.divFiterReport()}
                    <DataTable
                      rows={(reports || []).filter((el) => el.discipline === 'Asset Integrity')}
                      headers={headersDataTable}
                      useZebraStyles
                      size="compact"
                      render={({
                        rows,
                        headers,
                        getHeaderProps,
                        getRowProps,
                        getSelectionProps,
                        selectedRows,
                        getBatchActionProps,
                      }) => (
                        <TableContainer className="bx--grid-full-width">
                          {selectedRows.length > 0 ? (
                            <TableToolbar>
                              <TableToolbarContent>
                                <Online>
                                  <TableBatchActions {...getBatchActionProps()}>
                                    {CanExecuteAction(
                                      'Report',
                                      'Reporting',
                                      user,
                                      selectedRows.length > 0
                                        ? this.getStatusId(selectedRows[0].id)
                                        : null,
                                      'Submit',
                                      this.getReport(selectedRows)
                                    ) ? (
                                      <TableBatchAction
                                        renderIcon={Send16}
                                        onClick={() =>
                                          this.batchActionClick(
                                            'Submit',
                                            'Submit',
                                            'Data Approver',
                                            true,
                                            false,
                                            true,
                                            true,
                                            selectedRows
                                          )
                                        }
                                      >
                                        Submit Report
                                      </TableBatchAction>
                                    ) : null}

                                    {CanExecuteAction(
                                      'Report',
                                      'Reporting',
                                      user,
                                      selectedRows.length > 0
                                        ? this.getStatusId(selectedRows[0].id)
                                        : null,
                                      'Approve',
                                      this.getReport(selectedRows)
                                    ) ? (
                                      <TableBatchAction
                                        renderIcon={CheckmarkOutline16}
                                        onClick={() =>
                                          this.batchActionClick(
                                            'Approve',
                                            'Approve',
                                            'Division Manager',
                                            true,
                                            false,
                                            true,
                                            true,
                                            selectedRows
                                          )
                                        }
                                      >
                                        Approve Report
                                      </TableBatchAction>
                                    ) : null}

                                    {CanExecuteAction(
                                      'Report',
                                      'Reporting',
                                      user,
                                      selectedRows.length > 0
                                        ? this.getStatusId(selectedRows[0].id)
                                        : null,
                                      'Consolidate',
                                      this.getReport(selectedRows)
                                    ) ? (
                                      <TableBatchAction
                                        renderIcon={CheckmarkOutline16}
                                        onClick={() =>
                                          this.batchActionClick(
                                            'Consolidate',
                                            'Approve',
                                            null,
                                            false,
                                            false,
                                            true,
                                            true,
                                            selectedRows
                                          )
                                        }
                                      >
                                        Approve Report
                                      </TableBatchAction>
                                    ) : null}

                                    {CanExecuteAction(
                                      'Report',
                                      'Reporting',
                                      user,
                                      selectedRows.length > 0
                                        ? this.getStatusId(selectedRows[0].id)
                                        : null,
                                      'Reject',
                                      this.getReport(selectedRows)
                                    ) ? (
                                      <TableBatchAction
                                        renderIcon={Error16}
                                        onClick={() =>
                                          this.batchActionClick(
                                            'Reject',
                                            'Reject',
                                            null,
                                            false,
                                            true,
                                            true,
                                            true,
                                            selectedRows
                                          )
                                        }
                                      >
                                        Reject Report
                                      </TableBatchAction>
                                    ) : null}

                                    {CanExecuteAction(
                                      'Report',
                                      'Reporting',
                                      user,
                                      selectedRows.length > 0
                                        ? this.getStatusId(selectedRows[0].id)
                                        : null,
                                      'RejectConsolidate',
                                      this.getReport(selectedRows)
                                    ) ? (
                                      <TableBatchAction
                                        renderIcon={Error16}
                                        onClick={() =>
                                          this.batchActionClick(
                                            'RejectConsolidate',
                                            'Reject',
                                            null,
                                            false,
                                            true,
                                            true,
                                            true,
                                            selectedRows
                                          )
                                        }
                                      >
                                        Reject Report
                                      </TableBatchAction>
                                    ) : null}

                                    {CanExecuteAction(
                                      'Report',
                                      'Reporting',
                                      user,
                                      selectedRows.length > 0
                                        ? this.getStatusId(selectedRows[0].id)
                                        : null,
                                      'Delete',
                                      this.getReport(selectedRows)
                                    ) ? (
                                      <TableBatchAction
                                        renderIcon={Delete16}
                                        onClick={() =>
                                          this.batchActionClick(
                                            'Delete',
                                            'Delete',
                                            null,
                                            false,
                                            false,
                                            false,
                                            false,
                                            selectedRows
                                          )
                                        }
                                      >
                                        Delete Report
                                      </TableBatchAction>
                                    ) : null}
                                  </TableBatchActions>
                                </Online>
                              </TableToolbarContent>
                            </TableToolbar>
                          ) : (
                            ''
                          )}
                             
                    <ChangeCompilerModal
                    show={this.state.isChangeRequestModalOpen}
                    title="Change Compiler"
                    action={this.state.approvalModalAction}
                    withApprover={this.state.withApprover}
                    approver={this.state.approver}
                    approverRole={this.state.approverRole}
                    approverOptions={this.state.approvers}
                    isLoadingOperation={this.state.isLoadingWFOperation}
                    onApproverSelect={this.handleApproverSelect}
                    isLoadingOptions={this.state.isLoadingApproverOptions}
                    onCancel={this.handleCloseChangeCompilerModal}
                    onConfirm={this.handleChangeCompilerModal}
                    onApprovalNotesChange={this.handleApprovalNotesChange}
                    approvalNotes={this.state.approvalNotes}
                    approvalNotesRequired={this.state.approvalNotesRequired}
                    validationMessages={this.state.approvalValidationMessages}
                  />

                  <ConfirmCompilerModal
                    show={this.state.isConfirmRequestModalOpen}
                    title="Change Report Compiler"
                    action={this.state.approvalModalAction}
                    withApprover={this.state.withApprover}
                    approver={this.state.approver}
                    approverRole={this.state.approverRole}
                    approverOptions={this.state.approvers}
                    isLoadingOperation={this.state.isLoadingWFOperation}
                    onApproverSelect={this.handleApproverSelect}
                    isLoadingOptions={this.state.isLoadingApproverOptions}
                    onCancel={this.handleCloseConfirmCompilerModal}
                    onConfirm={this.handleConfirmCompilerModal}
                    onApprovalNotesChange={this.handleApprovalNotesChange}
                    approvalNotes={this.state.approvalNotes}
                    approvalNotesRequired={this.state.approvalNotesRequired}
                    validationMessages={this.state.approvalValidationMessages}
                  />
                          {this.state.isLoading ? (
                            <DataTableSkeleton
                              headers={[]}
                              rowCount={skeletonRowCount}
                              zebra={false}
                              compact={false}
                            />
                          ) : (
                            <Table className="">
                              <TableHead className="colorgray">
                                <TableRow>
                                  <TableHeader className="align-center" />
                                  {headers.map((header) => (
                                    <TableHeader
                                      className={header.type === 'bool' ? 'align-center' : ''}
                                      {...getHeaderProps({ header })}
                                    >
                                      {header.header}
                                    </TableHeader>
                                  ))}
                                  <TableHeader className="align-center">Actions</TableHeader>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {rows == null || rows.length === 0 ? (
                                  <NoRecordsPlaceholder colSpan={headers.length + 2} />
                                ) : (
                                  rows.map((row) => (
                                    <TableRow {...getRowProps({ row })}>
                                      <Online>
                                        {this.IsRowSelectable(row, selectedRows, user) ? (
                                          <TableSelectRow {...getSelectionProps({ row })} />
                                        ) : (
                                          <TableCell
                                            key={`empty${row.id}`}
                                            className="tableActions align-center"
                                          />
                                        )}
                                      </Online>
                                      <Offline>
                                        {this.IsRowSelectable(row, selectedRows, user) ? (
                                          <TableSelectRow
                                            {...getSelectionProps({ row })}
                                            disabled
                                          />
                                        ) : (
                                          <TableCell
                                            key={`empty${row.id}`}
                                            className="tableActions align-center"
                                          />
                                        )}
                                      </Offline>
                                      {row.cells.map((cell) => (
                                        <RenderDataTableCell
                                          key={cell.id}
                                          cell={cell}
                                          header={headers.find((x) => x.key === cell.info.header)}
                                        />
                                      ))}

                                      <TableCell
                                        key={`action-${row.id}`}
                                        className="tableActions align-center"
                                      >
                                        <div>
                                          <Link
                                            to={`/reportSummaries/${this.state.reportSummary.id}/${
                                              this.state.reportSummary.reports.find(
                                                (r) => r.id === row.id
                                              ).discipline
                                            }/${row.id}`}
                                          >
                                            <Button
                                              size="small"
                                              renderIcon={Edit16}
                                              iconDescription="Edit"
                                              kind="ghost"
                                            />
                                          </Link>
                                          <Online>
                                          {this.confirmChangeCompilerRequest(row.id, user) &&
                                            IsInRole(user, 'Administrator') && (
                                              <Button
                                              onClick={() => this.confirmCompilerActionClick([].concat(row))}
                                                size="small"
                                                renderIcon={UserAdmin16}
                                                title="Confirm New Compiler"
                                                iconDescription="Confirm New Compiler"
                                                kind="ghost"
                                              />
                                            )}
                                          { !this.isRequestChangeCompilerPending(row.id) && (
                                              <Button
                                                onClick={() => this.changeCompilerActionClick([].concat(row))}
                                                size="small"
                                                renderIcon={Collaborate16}
                                                title="Request Change Compiler"
                                                iconDescription="Request Change Compiler"
                                                kind="ghost"
                                              />
                                            )}
                                             {this.isRequestChangeCompilerPending(row.id) &&
                                              this.isReportCompiler(row.id) &&
                                              !this.confirmChangeCompilerRequest(row.id, user) &&
                                              (
                                              <Button
                                                onClick={() => this.changeCompilerActionClick([].concat(row))}
                                                size="small"
                                                renderIcon={Collaborate16}
                                                title="Request Pending"
                                                iconDescription="Request Pending"
                                                kind="ghost"
                                                disabled={true}
                                              />                                             
                                            )}
                                        </Online>   
                                        </div>
                                      </TableCell>
                                    </TableRow>
                                  ))
                                )}
                              </TableBody>
                            </Table>
                          )}
                        </TableContainer>
                      )}
                    />
                  </Tab>
 */}                
                </Tabs>

                {!this.state.isReportFormOpen ? '' : this.divFormReport()}

                <WFActionModal
                  show={this.state.isApprovalModalOpen}
                  title={`${this.state.approvalModalAction} Reports`}
                  action={this.state.approvalModalAction}
                  withApprover={this.state.withApprover}
                  approver={this.state.approver}
                  month={this.state.month}
                  trimester={this.state.trimester}
                  year={this.state.year}
                  onApprovalMonthChange={this.handleMonthSelect}
                  onApprovalTrimesterChange={this.handleTrimesterSelect}
                  onApprovalYearChange={this.handleYearSelect}
                  withTimeApproval={false}//{this.state.withTimeApproval}
                  approvalTimeIntervalType={this.state.approvalTimeIntervalType}
                  approverRole={this.state.approverRole}
                  approverOptions={this.state.approvers}
                  isLoadingOperation={this.state.isLoadingWFOperation}
                  onApproverSelect={this.handleApproverSelect}
                  isLoadingOptions={this.state.isLoadingApproverOptions}
                  onCancel={this.handleCloseApprovalModal}
                  onConfirm={this.handleConfirmApprovalModal}
                  onApprovalNotesChange={this.handleApprovalNotesChange}
                  approvalNotes={this.state.approvalNotes}
                  approvalNotesRequired={this.state.approvalNotesRequired}
                  validationMessages={this.state.approvalValidationMessages}
                  user={user} //RITM1064131
                />
              </div>
            </div>
          </>
        )}
      </AppContext.Consumer>
    );
  }
}

ReportSummary.contextType = AppContext;
